import { PRODT_URL, apiGetCall } from '@/api/apiDispatcher';

// Module-level cache — stores the in-flight or resolved promise per language
// When MainSearch mounts and calls prefetchProducts(), it gets the same promise
// that ProductsPreloader already started, potentially saving 300-600ms
const cache = {};

export function prefetchProducts(langStore) {
  if (!langStore) return Promise.resolve(null);
  if (!cache[langStore]) {
    cache[langStore] = apiGetCall(PRODT_URL, langStore).catch(() => null);
  }
  return cache[langStore];
}
